import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './BusinessNewDeal.css';
import BusinessSidebar from "../../BusinessSidebar";
import Header from "../../BusinessHeaderAfterLogin";
import Footer from "../../BusinessFooterAfterLogin";
import Image from 'react-bootstrap/Image';
import { Link, useNavigate } from 'react-router-dom';
import API from '../../../Utils/Api';


const BusinessNewDeal = () => {
    const navigate = useNavigate();

    const [data, setData] = useState('');
    useEffect(() => {
        document.title = `Business New Deal | Local Bells`;
        document.getElementById('bodywrap').className = 'businewdeal';

        let formData = new FormData();
        formData.append(`business_id`, localStorage.getItem("business_id"));
        API.post('get_business_detail', formData)
            .then(response => {

                if (response.data.status === false) {

                } else {
                    setData(response.data.data);
                }
            }).catch(error => {
                console.log('error ' + error);
            });

    }, []);

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };


    const handleClick = (e) => {
        e.preventDefault();

        // console.log("seller id " + data.slug);
        // console.log("name " + data.business_name);
        // console.log("contact " + data.business_contact_number);
        // console.log("location " + data.location[0].town_name);

        const message = `Seller ID: ${data.slug} | Name: ${data.business_name} | Contact: ${data.business_contact_number} | Location: ${data.location[0].town_name} | Membership: premium`;

        const phoneNumber = "918484040933"; // with country code
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

        window.open(whatsappURL, "_blank");

    };

    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <BusinessSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <div className='white-box'>
                                    <Row>
                                        <div className="d-flex align-items-start justify-content-between gap-3">
                                            <div >
                                                <h3>Add New Deal</h3>
                                                <h6>Select Deal Type</h6>
                                            </div>
                                            <Link to="#" onClick={() => navigate(-1)} className='cross-up'>
                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid crosy" alt="wp" />
                                            </Link>
                                        </div>
                                    </Row>
                                    <Row>
                                        <Col xs={12}>
                                            <Link to="/business/product-sale" className='np-box'>
                                                <Row className='mx-0'>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/pticn1.webp'} className="img-fluid np-icn" alt="pticn1" />
                                                    </Col>
                                                    <Col>
                                                        <h6>Specific Product/Service Deal</h6>
                                                        <p>Examples: Buy 1 Get 1 Free H&S Shampoo, ₹200 Discount Priya Mixer , Rs.5000 off LG TV , Rs.20 Discount on Mens Haircut , Rs.50 Off Entry to Trampling Park etc</p>
                                                    </Col>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/arrow.webp'} className="img-fluid np-arrow" alt="arrow" />
                                                    </Col>
                                                </Row>
                                            </Link>
                                        </Col>
                                        <Col xs={12}>
                                            <Link to="/business/store-sale" className='np-box'>
                                                <Row className='mx-0'>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/pticn2.webp'} className="img-fluid np-icn" alt="pticn2" />
                                                    </Col>
                                                    <Col>
                                                        <h6>General Deal</h6>
                                                        <p>Examples: 25% Off on All Purchases ,10% Off on Orders Above ₹1000 , 30% Off on Kitchenware etc</p>
                                                    </Col>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/arrow.webp'} className="img-fluid np-arrow" alt="arrow" />
                                                    </Col>
                                                </Row>
                                            </Link>
                                        </Col>
                                        <Col xs={12} className='d-none'>
                                            <Link to="/business/discount-sale" className='np-box'>
                                                <Row className='mx-0'>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/pticn3.webp'} className="img-fluid np-icn" alt="pticn3" />
                                                    </Col>
                                                    <Col>
                                                        <h6>Service/To Do Discount Sale</h6>
                                                        <p>Home services , Entertainment , Tutors , Classes.</p>
                                                    </Col>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/arrow.webp'} className="img-fluid np-arrow" alt="arrow" />
                                                    </Col>
                                                </Row>
                                            </Link>
                                        </Col>
                                        <Col xs={12}>
                                            <Link to="/business/freeitem-sale" className='np-box'>
                                                <Row className='mx-0'>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/pticn4.webp'} className="img-fluid np-icn" alt="pticn4" />
                                                    </Col>
                                                    <Col>
                                                        <h6>Offer Free</h6>
                                                        <p>Example : Free Soap with ₹100+ Purchase , Free Iron with Any TV , Free Notebook - No Purchase Required etc</p>
                                                    </Col>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/arrow.webp'} className="img-fluid np-arrow" alt="arrow" />
                                                    </Col>
                                                </Row>
                                            </Link>
                                        </Col>
                                        <Col xs={12} className='my-3'>
                                            <h4 className='mb-0'>OR</h4>
                                        </Col>
                                        <Col xs={12}>
                                            <Link to="" onClick={handleClick} className='np-box'>
                                                <Row className='mx-0'>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/whatsapp-round.webp'} className="img-fluid np-icn" alt="whatsapp-round" />
                                                    </Col>
                                                    <Col>
                                                        <h6>Add new deal via WhatsApp</h6>
                                                        <p>WhatsApp us your deal offering -- we'll polish it professionally and post on your behalf</p>
                                                    </Col>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/arrow.webp'} className="img-fluid np-arrow" alt="arrow" />
                                                    </Col>
                                                </Row>
                                            </Link>
                                        </Col>
                                    </Row>
                                </div>
                                <div className='footer-org footer'>
                                    <Footer />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default BusinessNewDeal;


